$(document).ready(function () {
	 $(".collection-archive  .ac_single_collection .ac_col_content").hide();
 	$(".collection-re-work .ac_single_collection").addClass("active");
	$(".collection-archive .ac_single_collection:nth-child(2)").addClass("active");
	$(".collection-archive .ac_single_collection:nth-child(2) .ac_col_content").show();
	$(".collection-archive .ac_single_collection:first-child").addClass("active");
	$(".collection-archive .ac_single_collection:first-child .ac_col_content").show();

	$(".ac_single_collection").each(function () {
		if (this.querySelectorAll('.product-item').length == 0) {
			$(this).find("#CollectionLoop").hide();
			$(this).find(".no_products").show();
		  }
	});

	$(".ac_single_collection").click(function () {
		const self = $(this);
		$(this).children(".ac_col_content").slideToggle(300, function () {
			const scrollTop = self.offset().top-40;
			$('html, body').stop().animate({
				scrollTop
			}, 300);

		});
		$(this).toggleClass("active");
      
      
      if (this.querySelectorAll('.product-item').length == 0) {
        $(this).find("#CollectionLoop").hide();
        $(this).find(".no_products").show();
      }
	  
	});
	 
});

$(function () {
	let active_year = 'all';
	let active_month = 'all';

	$('.col_nav .col_left li').click(function(){
		const target = $(this).attr("data-tag");
		$('.col_nav .col_left li').removeClass("active");
		$('.col_nav .col_right li').removeClass("active");
		$(this).addClass('active');
		$(`.col_nav .child[data-tag="${target}"]`).removeClass("hidden");
		$(`.col_nav .child[data-tag="${target}"]`).siblings().addClass("hidden");
		active_year = target;
		if(active_year == 'all'){
			$(`.col_nav .child`).addClass("hidden");
		}
		
	});

	$('.col_nav .col_right li').click(function(){
		const targetchild = $(this).attr("data-tag-child");
		$('.col_nav .col_right li').removeClass("active");
		$(this).addClass('active');
		active_month = targetchild;
	});

	$('.jtb_drop_down .jtb_dd_show').click(function(){
		$('.jtb_drop_down .col_nav').slideToggle();
	});
  
  $('.jtb_drop_down .col_nav').on('mouseleave',function(){
		$(this).slideUp();
	});

	$('.jtb_drop_down .col_nav .btn_apply').click(function(){
		$('.ac_single_collection').each(function(){
			const this_year = $(this).attr('data-year');
			const this_month = $(this).attr('data-month');

			if(active_year == 'all'){
				$(this).removeClass('disable');
			}else {
				if(active_year == this_year){
					if(active_month == 'all' || active_month == this_month){
						$(this).removeClass('disable');	
					}else {
						$(this).addClass('disable');
						$(this).removeClass('active');
						$(this).find('.ac_col_content').slideUp();	
					}
				}else {
					$(this).addClass('disable');
					$(this).removeClass('active');
					$(this).find('.ac_col_content').slideUp();
				}
			}
		});
		$('.jtb_drop_down .col_nav').slideToggle();

		$('.ac_single_collection:not(.disable)').find('.ac_col_content').slideDown();
		$('.ac_single_collection:not(.disable)').addClass('active');

		if(active_year != 'all'){
			$('.jtb_drop_down').find('.jtb_dds_filter').text(active_year);
			if(active_month != 'all'){
				$('.jtb_drop_down').find('.jtb_dds_filter').text(active_month + " " + active_year);
			}
		}else{
			$('.jtb_drop_down').find('.jtb_dds_filter').text('All');
		}
	});
	
});